<script setup lang="ts">
import { useForm } from "@inertiajs/vue3"
import AuthShell from "./components/AuthShell.vue"

const props = defineProps<{
  email?: string
  errors?: Record<string, string[]>
}>()

const form = useForm({
  email: props.email ?? "",
})

const fieldError = (field: string) => props.errors?.[field]?.[0]
</script>

<template>
  <AuthShell title="Recuperar senha" subtitle="Envie seu e-mail para receber o link de redefinição.">
    <form class="space-y-4" @submit.prevent="form.post('/users/password')">
      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="email">E-mail</label>
        <input id="email" v-model="form.email" type="email" required class="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200" />
        <p v-if="fieldError('email')" class="mt-1 text-sm text-rose-600">{{ fieldError('email') }}</p>
      </div>

      <button type="submit" :disabled="form.processing" class="w-full rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60">
        Enviar link de redefinicao
      </button>
    </form>
  </AuthShell>
</template>
